<div *ngIf='componentReady' class='ManageSubscriptionDialog'>
  <ng-container *ngIf='hasSubscription; else noSubsciprtion'>
    <div [formGroup]='inputForm' class='ManageSubscriptionDialog__form'>
      <div class='row'>
        <div class='col col-12 col-md-6 align-content-center'>
          <mat-label>Plan</mat-label>
        </div>
        <div class='col col-12 col-md-6'>
          <app-select [items]='planItems' formControlName='plan_id' label='Selected plan...'></app-select>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <mat-accordion>
            <mat-expansion-panel [expanded]='false'>
              <mat-expansion-panel-header>
                <mat-panel-title>Current Plan Details</mat-panel-title>
              </mat-expansion-panel-header>
              <div class='ManageSubscriptionDialog__form__plan-details'>
                <div class='row'>
                  <div class='col col-12 col-md-6'>
                    <mat-label>Amount</mat-label>
                  </div>
                  <div class='col-12 col-md-6'>
                    <b>${{ getSubscriptionAmount() }}</b>
                  </div>
                </div>
                <div class='row mt-3'>
                  <div class='col col-12 col-md-6'>
                    <mat-label>Interval</mat-label>
                  </div>
                  <div class='col col-12 col-md-6'>
                    <b>{{ subscription.payment_interval }}</b>
                  </div>
                </div>
                <div class='row mt-3'>
                  <div class='col col-12 col-md-6'>
                    <mat-label>Period</mat-label>
                  </div>
                  <div class='col col-12 col-md-6'>
                    <b>{{ subscription.payment_period }}</b>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6 align-content-center'>
          <mat-label>Customer</mat-label>
        </div>
        <div class='col col-12 col-md-6 ali'>
          <app-text-field [canCopy]='true' formControlName='customer_id' label='Customer'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6 align-content-center'>
          <mat-label>Subscription ID</mat-label>
        </div>
        <div class='col col-12 col-md-6'>
          <app-text-field [canCopy]='true' [disabled]='true' [value]='subscription.subscription_id'
                          label='Subscription ID'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6 align-content-center'>
          <mat-label>Team Code</mat-label>
        </div>
        <div class='col col-12 col-md-6'>
          <app-text-field [canCopy]='true' formControlName='discount' label='Select discount'></app-text-field>
        </div>
      </div>
      <div *ngIf='subscription.team_code' class='row mt-3'>
        <div *ngIf='subscription.team_code' class='col col-12 col-md-6 offset-0 offset-md-6 align-content-center'>
          Remove Discount:
          <mat-slide-toggle formControlName='discard_discount'></mat-slide-toggle>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6'>
          Payed by manager<br />
          <span class='text-muted'>Functionality paid by manager becomes active if user is assigned to a manager</span>
        </div>
        <div class='col col-12 col-md-6'>
          <mat-slide-toggle [disabled]='subscription.paid_by_manager || !account.manager_id'
                            formControlName='manager_pay'></mat-slide-toggle>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #noSubsciprtion>
    <div class='alert alert-danger'>
      <p>Account <b>{{ account.email }}</b> has not subscription!</p>
      <p>You can change the customer ID only</p>
      <p>Email address in Retreva app should match email address in Stripe of the selected customer ID</p>
      <div [formGroup]='inputForm' class='ManageSubscriptionDialog__form'>
        <div class='row mt-3'>
          <div class='col col-12 col-md-6 align-content-center'>
            <mat-label>Customer</mat-label>
          </div>
          <div class='col col-12 col-md-6 ali'>
            <app-text-field [canCopy]='true' formControlName='customer_id' label='Customer'></app-text-field>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>